
// 资源复制
Vue.component("resource_copy_modal", {
  data() {
      return {
          visible: false,
          name:'',
          list: [],
          props: {
              label: 'name',
              children: 'children'
          },
          currentSelected: null,
          contentId: '',
          currentResource: {},
          loading: true,
      };
  },
  methods: {
      open({contentId, type}) {
          this.currentResource = {contentId, type}
          this.name = ''
          this.currentSelected = null
          this.loading = true
          this.visible = true
      },
      handleCheckChange(data, checked, indeterminate) {
          console.log(data, checked, indeterminate);
          this.currentSelected = data
      }, 
      handleNodeClick(data) {
          console.log(data);
      },
      loadNode(node, resolve) {
          if (node.level === 0) {
              API.reqFolderList(2).then(res=>{
                  this.loading = false
                  // console.log(res)
                  if(res.success){
                      let arr = [res.data.find(el=>el.name == '个人资源'),...res.data.find(el=>el.name == '公共资源').children]
                      // console.log(arr)
                      arr = arr.filter(el=>el.name != '录播资源').map(el=>({...el,disabled:el.name=='群组资源'}))
                      console.log(arr)
                      return resolve(arr)
                  }
              })
          }else{
              API.reqFolderPath(node.data.path).then(res=>{
                  console.log(res)
                  if(res.success){
                      return resolve(res.data)
                  }
              })
          }
      },
      handleConfirm(){
          if(!this.currentSelected) return this.$message.info(this.$t('请选择文件夹'))
          let param = {
              contentId: this.currentResource.contentId,
              copyEntity: {
                  tree: [this.currentSelected.path],
                  type: this.currentResource.type
              }
          }
          if(this.name) param.name = this.name
          API.reqResourceCopy(param).then(res=>{
              if(res.success){
                  this.$message.success(this.$t('复制成功'))
                  this.visible = false
              }else{
                  this.$message.error(this.$t('复制失败'))
              }
          })
      },
  },
  template: `
      <el-dialog :visible.sync="visible" :title="$t('复制到')" width="400px">
          <el-button type="primary" size="small">{{$t('新建文件夹')}}</el-button>
          <div style="display: flex;align-items: center;gap: 4px;margin: 20px 0;white-space: nowrap">
              {{$t('重命名')}}：<el-input v-model="name" size="small"></el-input>
          </div>
          <el-empty v-if="loading" v-loading="loading"></el-empty>
          <el-tree
            v-if="visible"
            v-show="!loading"
            :props="props"
            :load="loadNode"
            lazy
            check-on-click-node
            :highlight-current="true"
            @check-change="handleCheckChange"
            class="folder_tree">
            <template class="custom-tree-node" slot-scope="{ node, data }">
              <div v-if="node.disabled" @click.stop="()=>null" style="cursor:not-allowed;width:calc(100% - 24px);color:#ccc"><i class="el-icon-folder"></i><i class="el-icon-folder-opened"></i>{{ node.label }}</div>
              <div v-else><i class="el-icon-folder"></i><i class="el-icon-folder-opened"></i>{{ node.label }}</div>
            </template>
          </el-tree>
          <div slot="footer">
              <el-button type="primary" @click="handleConfirm" size="small">{{$t('确定')}}</el-button>
              <el-button @click="visible = false" size="small">{{$t('取消')}}</el-button>
          </div>
      </el-dialog>
  `,
});